import React from 'react';
import { Text } from '@cuemath/comps';
import { COLORS } from '@cuemath/comps';
import styled from 'styled-components';

const TextContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 56px;
`;

const SuccessModal = () => {
  return (
    <TextContainer>
      <Text color={COLORS.GREEN} size="large" weight="bolder">
        Lead Successfully Added
      </Text>
    </TextContainer>
  );
};
export default SuccessModal;
